import { Link } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledLink = styled(Link)`
  cursor: pointer;
`;